





























































































import Base from '@/views/Base';
import { Component, Prop } from 'vue-property-decorator';
import { PresentationTableItem } from '@/models/Presentation';
import { getThumbnailUrl } from '@/utils/filters';
import SurveyForm from '@/assets/pictures/survey_form.svg';
import PieChart from '@/assets/pictures/pie_chart.svg';

@Component({
  components: { PieChart, SurveyForm }
})
export default class PresentationCard extends Base {
  @Prop() item!: PresentationTableItem;

  getThumbnailUrl = getThumbnailUrl

  getTTL(item: PresentationTableItem): number {
    const now = new Date();
    const updated = new Date(item.dateUpdated);
    updated.setFullYear(updated.getFullYear() + 1);

    const diff = Math.max(updated.getTime() - now.getTime(), 0);
    // return days to live
    return Math.floor(diff / (1000 * 3600 * 24));
  }

  emitEditPresentation(item: PresentationTableItem): void {
    if (!item.isGlobal || this.hasPermission('CUSTOMER_PRESENTATION')) {
      this.$emit('edit-presentation', item);
    }
  }

  cardSelected(item: PresentationTableItem, shiftKey: boolean): void {
    if (item.isGlobal && !this.hasPermission('CUSTOMER_PRESENTATION')) return;
    this.$emit('card-selected', item, shiftKey);
  }

  get thumbnailUrl(): string {
    return `${this.item.thumbnailUrl}?token=${this.user.resourceAccessToken}`;
  }

}
